<template>
  <div class="creation-demand-step-comment">
    <form @submit.prevent="save">
      <h2 class="step-title-optional">
        {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@COMMENT_TITLE")) }}
      </h2>

      <section class="q-mt-xl">
        <QInput
          v-model.trim="comment"
          filled
          stack-label
          :placeholder="stepAssets.comment_placeholder"
          type="textarea"
          counter
          :maxlength="XXLONG_TEXT_LENGTH_LIMIT"
        />
      </section>
      <ExtraTipbox class="q-my-md">
        <span>{{ $t("ETAB.PAGES.DEMANDS.CREATION.@COMMENT_TIPBOX") }}</span>
      </ExtraTipbox>
      <transition appear enter-active-class="animated fadeIn slower delay-1s" leave-active-class="animated fadeOut">
        <section class="q-footer q-layout__section--marginal fixed-bottom">
          <div>
            <QBtn
              color="secondary"
              class="full-width btn-navigation"
              :label="$t('ETAB.BUTTONS.@NEXT')"
              no-caps
              type="submit"
              :loading="loading"
              :disabled="loading"
            />
          </div>
        </section>
      </transition>
    </form>
  </div>
</template>

<script>
  import { XXLONG_TEXT_LENGTH_LIMIT } from "@core/constants";
  import { CreationStepCommentModel, ICreationStepComment } from "@core/models";

  export default {
    props: {
      stepAssets: {
        type: Object,
        default: () => ({}),
      },
      stepData: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["saveStep"],
    data() {
      return {
        comment: undefined,
      };
    },
    computed: {
      stepDataModel() {
        return new CreationStepCommentModel(this.stepData);
      },
    },
    created() {
      this.comment = this.stepDataModel.getComment();
      this.XXLONG_TEXT_LENGTH_LIMIT = XXLONG_TEXT_LENGTH_LIMIT;
    },
    methods: {
      save() {
        let comment = this.comment;
        if (!this.comment || this.comment === "") {
          comment = undefined;
        }
        this.$emit("saveStep", { [ICreationStepComment.comment]: comment });
      },
    },
  };
</script>
<style lang="scss">
  .creation-demand-step-comment {
    margin-bottom: 80px;
  }
</style>
